import api from '@/utils/api';
import {
    GET_IMAGE_FOLDERS,
    CREATE_IMAGE_FOLDER,
    UPDATE_IMAGE_FOLDER,
    DELETE_IMAGE_FOLDER,
    UPLOAD_IMAGES,
    UPDATE_IMAGE,
    DELETE_IMAGE
} from './types';
import { NotificationManager } from 'react-notifications';

/** ================== FOLDERS ================== */

// Lấy danh sách thư mục theo customer
export const getImageFolders = (customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/images/customers/${customerId}/image-folders`)
            .then(res => {
                dispatch({
                    type: GET_IMAGE_FOLDERS,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi tải danh sách thư mục ảnh");
                reject(err);
            });
    });
};

export const getFolderImages = (customerId, params) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/images/customers/${customerId}/folder-images`, { params })
            .then(res => resolve(res.data))
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi tải danh sách ảnh");
                reject(err);
            });
    });
};

// Tạo thư mục mới
export const createImageFolder = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/images/image-folders`, data)
            .then(res => {
                dispatch({
                    type: CREATE_IMAGE_FOLDER,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || "Tạo thư mục thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi tạo thư mục");
                reject(err);
            });
    });
};

// Cập nhật thư mục
export const updateImageFolder = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/images/image-folders/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_IMAGE_FOLDER,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || "Cập nhật thư mục thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi cập nhật thư mục");
                reject(err);
            });
    });
};

// Xóa thư mục (nếu cần)
export const deleteImageFolder = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.delete(`/images/image-folders/${id}`)
            .then(res => {
                dispatch({
                    type: DELETE_IMAGE_FOLDER,
                    payload: id
                });
                NotificationManager.success(res.data.msg || "Xóa thư mục thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi xóa thư mục");
                reject(err);
            });
    });
};

/** ================== IMAGES ================== */

// Upload ảnh vào thư mục
export const uploadImages = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/images/customers/${customerId}/images`, data)
            .then(res => {
                dispatch({
                    type: UPLOAD_IMAGES,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || "Tải ảnh lên thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi tải ảnh");
                reject(err);
            });
    });
};

// Cập nhật thông tin ảnh
export const updateImage = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/images/images/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_IMAGE,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || "Cập nhật ảnh thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi cập nhật ảnh");
                reject(err);
            });
    });
};

// Xóa ảnh
export const deleteImage = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.delete(`/images/images/${id}`)
            .then(res => {
                dispatch({
                    type: DELETE_IMAGE,
                    payload: id
                });
                NotificationManager.success(res.data.msg || "Xóa ảnh thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi xóa ảnh");
                reject(err);
            });
    });
};

// Cập nhật folder/phạm vi cho nhiều ảnh trong một request atomic ở backend.
export const batchUpdateImages = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/images/customers/${customerId}/images/batch`, data)
            .then(res => {
                NotificationManager.success(res.data.msg || "Cập nhật ảnh thành công!");
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || "Lỗi khi cập nhật các ảnh đã chọn");
                reject(err);
            });
    });
};
